import { render, staticRenderFns } from "./ks-investor-6.vue?vue&type=template&id=07e7f960"
var script = {}
import style0 from "./ks-investor-6.vue?vue&type=style&index=0&id=07e7f960&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports